/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/pages/auth/AuthPage`, `src/pages/home/HomePage`).
 */

import React from "react";
import { useLocation, Route, Switch, withRouter } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { useLastLocation } from "react-router-last-location";
import HomePage from "../pages/home/HomePage";
import ErrorsPage from "../pages/errors/ErrorsPage";
import LogoutPage from "../pages/auth/Logout";
import { LayoutContextProvider } from "../../_metronic";
import Layout from "../../_metronic/layout/Layout";
import * as routerHelpers from "../router/RouterHelpers";
import AuthPage from "../pages/auth/AuthPage";
import DialogLayout from "../partials/content/DialogLayout";
import LoginForm from "../pages/auth/LoginForm";

export const Routes = withRouter(({ history }) => {
  const lastLocation = useLastLocation();
  const location = useLocation();
  routerHelpers.saveLastLocation(lastLocation);
  const { isAuthorized, menuConfig, userLastLocation } = useSelector(
    ({ auth, urls, builder: { menuConfig } }) => ({
      menuConfig,
      isAuthorized: auth.authToken != null,
      userLastLocation: routerHelpers.getLastLocation(),
    }),
    shallowEqual
  );

  return (
    /* Create `LayoutContext` from current `history` and `menuConfig`. */
    <React.Fragment>
      <LayoutContextProvider history={history} menuConfig={menuConfig}>
        <Switch>
          {!isAuthorized &&
          (location.pathname === "/auth/login" ||
            location.pathname === "" ||
            location.pathname === "/") ? (
            /* Render auth page when user at `/auth` and not authorized. */
            <AuthPage />
          ) : null}

          <Route path="/error" component={ErrorsPage} />
          <Route path="/logout" component={LogoutPage} />

          <Layout history={history}>
            <HomePage userLastLocation={userLastLocation} />
          </Layout>
        </Switch>
      </LayoutContextProvider>
      <DialogLayout
        open={!isAuthorized && location.pathname !== "/auth/login"}
        title="Session Expired"
        maxWIdth="sm"
        onCloseDialog={() => {
          history.push("/auth/login");
        }}
      >
        <div className="kt-login__wrapper">
          <LoginForm />
        </div>
      </DialogLayout>
    </React.Fragment>
  );
});
